<template>
<div class="x_box">
    <ol class="breadcrumb x_breadcrumb">
        <li class="breadcrumb-item">
            <router-link to="/purchase/invoices">{{ $t('purchase_invoice') }}</router-link>
        </li>
        <li class="breadcrumb-item active" aria-current="page">{{ $route.params.id ? $t('update') : $t('new')  }}</li>
    </ol>
    <div class="x_header">
        <button type="button"
                class="btn btn-outline-primary btn-sm no-bor"
                @click="$router.go(-1)">
            <i class="fa fa-arrow-circle-o-left"/>
            {{ $t('back') }}
        </button>
        <b-btn variant="outline-primary no-bor"
               size="sm"
               @click="onSave('')">
            <i class="fa fa-floppy-o" aria-hidden="true"/>
            {{$t('save')}}
        </b-btn>
        <b-btn variant="outline-primary no-bor"
               size="sm"
               @click="onSave('new')">
            <i class="fa fa-floppy-o" aria-hidden="true"/>
            {{$t('save_and_new')}}
        </b-btn>
        <b-btn variant="outline-primary no-bor"
               size="sm"
               @click="onSave('print')">
            <i class="fa fa-floppy-o" aria-hidden="true"/>
            {{$t('save_and_print')}}
        </b-btn>
    </div>
    <div class="x_body">
        <div class="card f_card">
            <div class="card-body">
                <div class="row">
                    <div class="col-md-7 col-12">
                        <div class="row">
                            <div class="col-sm-9">
                                <div class="form-group" :class="{ 'form-group-error': $v.invoice.AccountId.$error }">
                                    <label class="label-control blue">{{$t('account_payable')}}</label>
                                    <div>
                                        <select class="form-control form-control-sm" v-model="$v.invoice.AccountId.$model">
                                            <option v-for="ret in account_payables" :value="ret.Id" :key="ret.Id">{{ret.Name}}</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">                    
                            <div class="col-sm-8">
                                <div class="form-group" :class="{ 'form-group-error': $v.invoice.VendorId.$error }">
                                    <label class="label-control blue">{{ $t('vendor') }}</label>
                                    <div>
                                        <VendorSelector @select="vendorSelected" :v-add-new="true" :value="invoice.VendorName"/>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-4">
                                <div class="form-group">
                                    <label class="label-control blue">{{ $t('bill_no') }}</label>
                                    <div>
                                        <!-- <PurchaseOrderSelector :vendor-id="invoice.VendorId" @selected="poChange"></PurchaseOrderSelector> -->
                                        <input type="text" class="form-control form-control-sm" v-model="invoice.Num" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">                            
                            <div class="col-sm-4">                            
                                <div class="form-group" :class="{ 'form-group-error': $v.invoice.Date.$error }">
                                    <DatePicker v-model="date" :label="$t('date')"/>    
                                </div>                                
                            </div>  
                            <div class="col-sm-4">
                                <DatePicker v-model="due_date" :label="$t('due_date')"/>                                
                            </div>
                            <div class="col-sm-4">
                                <div class="form-group">
                                    <label class="label-control blue">{{$t('ref_no')}}</label>
                                    <div>
                                        <input type="text" class="form-control form-control-sm" v-model="invoice.RefNum" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-12">
                                <div class="form-group">
                                    <label class="label-control blue">{{$t('bill_memo')}}</label>
                                    <div>
                                        <input type="text" class="form-control form-control-sm" v-model="invoice.Memo" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-2 col-sm-6"></div>
                    <div class="col-md-3 col-sm-6 col-12">
                        <div class="card f_card rounded">
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-sm-10 mx-auto">
                                        <div class="form-group">
                                            <label class="label-control blue">{{$t('amount_usd')}}</label>
                                            <div>
                                                <input disabled type="text" class="form-control form-control-sm" v-model="invoice.PaidAmount" />
                                            </div>
                                        </div>
                                    </div>                                    
                                </div>
                                <div class="row">
                                    <div class="col-sm-10 mx-auto">
                                        <div class="form-group">
                                            <label class="label-control blue">{{$t('amount_khr')}}</label>
                                            <div>
                                                <input disabled type="text" class="form-control form-control-sm" v-model="AmountKHR" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>                        
                    </div>
                </div>
                <div class="mt-2">
                    <div>
                        <ul class="nav text-black mb-3 border-bottom">
                            <li class="nav-item">
                                <button class="nav-link" 
                                :class="[
                                    {   
                                        'rounded-0 border-primary none-border font-weight-bold bg-transparent': Tabs(3),
                                        'border-0 bg-transparent': !Tabs(3)
                                    }
                                ]" data-target="#nav-home" 
                                @click.prevent="OnTabs(3)" data-bs-toggle="tab"
                                >{{$t('Expenses')}}</button>
                            </li>
                            <li class="nav-item">
                                <button class="nav-link"
                                :class="[
                                        {   
                                            'rounded-0 border-primary none-border font-weight-bold bg-transparent': Tabs(1),
                                            'border-0 bg-transparent': !Tabs(1)
                                        }
                                    ]" 
                                @click.prevent="OnTabs(1)" 
                                >{{$t('Items')}}</button>
                            </li>
                        </ul>
                    </div>
                    <div class="tab-content border-0" id="nav-tabContent">
                        <div class="col-sm-12" :class="{ 'd-none' :Tabs(1) }">
                            <table class="table table-bordered table-sm no-bor">
                                    <thead>                                
                                        <tr>
                                            <th style="min-width:30px; vertical-align: middle;"></th>
                                            <th style="min-width: 300px;">{{$t('account')}}</th>
                                            <th style="min-width: 400px;">{{$t('description')}}</th>
                                            <th style="min-width: 75px;" class="text-right">{{$t('amount')}}</th>
                                            <th style="min-width: 100px;" class="text-left">{{$t('branch')}}</th>
                                            <!-- <th style="min-width: 125px;" class="text-right">{{$t('exchange_rate')}}</th> -->
                                        </tr>
                                    </thead>
                                    <tbody class="invoice-line">                              
                                        <tr v-for="(ret,index) in expense_lines" :key="index">
                                            <td style="width: 30px;">
                                                <button type="button"
                                                    class="btn btn-danger btn-remove"
                                                    @click="removeLine(index)">                                                        
                                                    X
                                                </button>
                                            </td>
                                            <td>                                                            
                                                <AccountAutoComplete :isBillLine="true" :vItems="accounts" @select="selectAccount($event, ret)" :value="ret.AccountName"/>
                                            </td>
                                            <td class="text-center">
                                                <input type="text" class="form-control form-control-sm" v-model="ret.Description" :disabled="ret.AccountId==''">
                                            </td>                                    
                                            <td class="text-right">
                                                <input type="text"
                                                    class="form-control form-control-sm text-right no-spinner"
                                                    v-model="ret.Price" 
                                                    @keypress="$isKeyNumber"
                                                    @change="reCalculate"
                                                    :disabled="ret.AccountId==''"
                                                />
                                            </td>
                                            <td class="text-left">
                                                <div>
                                                    <select class="form-control form-control-sm" v-model="ret.BranchId" :disabled="ret.AccountId===''">
                                                        <option v-for="ret in branches" :value="ret.Id" :key="ret.Id">{{ret.Name}}</option>
                                                    </select>                                            
                                                </div>
                                            </td>
                                            <!-- <td class="text-right">
                                                <input type="number"
                                                    class="form-control form-control-sm text-right"
                                                    v-model="invoice.ExchangeRate"
                                                    disabled
                                                />
                                            </td>                                                                                -->
                                        </tr>      
                                        <tr>
                                            <td class="none-ltb none-right"></td>
                                            <td class="none-ltb none-right">
                                                <button type="button"
                                                        class="btn btn-outline-primary btn-sm no-bor"
                                                        @click="addLine('expense')">
                                                    <i class="fa fa-plus"/>
                                                    {{ $t('add_line') }}
                                                </button>
                                            </td>
                                            <th colspan="2" class="none-ltb text-right">{{$t('total')}}:</th>
                                            <th class="text-right">{{$money(invoice.GrandTotal)}}</th>
                                        </tr>
                                        <tr>
                                            <th colspan="4" class="none-ltb text-right">{{$t('taxes')}}:</th>
                                            <th class="text-right">{{$money(invoice.TaxVat)}}</th>
                                        </tr>
                                        <tr>
                                            <th colspan="4" class="none-ltb text-right">{{$t('grand_total')}}:</th>
                                            <th class="text-right">{{$money(invoice.PaidAmount)}}</th>
                                        </tr>
                                    </tbody>
                            </table>
                        </div>
                        <div class="col-sm-12" :class="{'d-none': Tabs(3) }">
                            <table class="table table-bordered table-sm no-bor">
                                    <thead>
                                        <tr>
                                            <th style="min-width:30px; vertical-align: middle;"></th>
                                            <th style="min-width:300px">{{$t('item_name')}}</th>
                                            <th style="min-width:400px">{{$t('description')}}</th>
                                            <th style="min-width:50px" class="text-right">{{$t('qty')}}</th>
                                            <th style="min-width:75px" class="text-right">{{$t('price')}}</th>
                                            <th style="min-width:75px" class="text-right">{{$t('amount')}}</th>
                                            <th style="min-width:100px" class="text-left">{{$t('branch')}}</th>
                                            <!-- <th style="min-width:100px" class="text-right">{{$t('exchange_rate')}}</th> -->
                                        </tr>                               
                                    </thead>
                                    <tbody class="invoice-line">
                                        <tr v-for="(ret,index) in lines" :key="index" style="max-height: 20px;">
                                            <td style="width: 30px;">
                                                <button type="button"
                                                        class="btn btn-danger btn-remove"
                                                        style="height: 20px;"
                                                        @click="removeLine(index)">
                                                    X
                                                </button>
                                            </td>
                                            <td>
                                                <AuthCompleted :vLineNo="index" :vAddNew="true" :productType="'4'" :isBillLine="true" @select="select($event, ret)" :value="ret.ItemName"/>
                                            </td>
                                            <td class="text-center">
                                                <input type="text" class="form-control form-control-sm border-0" v-model="ret.Description" :disabled="ret.ItemId==''">
                                            </td>
                                            <td class="text-right">
                                                <input type="number"
                                                    class="form-control form-control-sm border-0 text-right no-spinner"
                                                    v-model="ret.Quantity"
                                                    @keypress="$isKeyNumber"
                                                    @change="reCalculate"
                                                    :disabled="ret.ItemId==''">
                                            </td>                                    
                                            <td class="text-right">
                                                <input type="number"
                                                    class="form-control form-control-sm border-0 text-right no-spinner"
                                                    v-model="ret.Price"
                                                    @keypress="$isKeyNumber"
                                                    @change="reCalculate"
                                                    :disabled="ret.ItemId===''">
                                            </td>
                                            <td class="text-right">
                                                <input type="text"
                                                    class="form-control form-control-sm text-right border-0 text-right no-spinner"
                                                    :value="$money(ret.SubTotal)" disabled />
                                            </td>
                                            <td class="text-left">
                                                <div>
                                                    <select class="form-control form-control-sm border-0" v-model="ret.BranchId" :disabled="ret.ItemId===''">
                                                        <option v-for="ret in branches" :value="ret.Id" :key="ret.Id">{{ret.Name}}</option>
                                                    </select>
                                                </div>
                                            </td>
                                            <!-- <td class="text-right">
                                                <input type="number"
                                                    class="form-control form-control-sm border-0 text-right"
                                                    v-model="invoice.ExchangeRate"
                                                    disabled
                                                />
                                            </td>                              -->
                                        </tr>
                                        <tr>
                                            <td class="none-ltb none-right"></td>
                                            <td class="none-ltb none-right">
                                                <button type="button"
                                                        class="btn btn-outline-primary btn-sm no-bor"
                                                        @click="addLine('item')">
                                                    <i class="fa fa-plus"/>
                                                    {{ $t('add_line') }}
                                                </button>
                                            </td>
                                            <th colspan="4" class="text-right none-ltb">{{$t('total')}}:</th>
                                            <th class="text-right">{{$money(invoice.GrandTotal)}}</th>
                                        </tr>
                                        <tr>
                                            <th colspan="6" class="none-ltb text-right">{{$t('taxes')}}:</th>
                                            <th class="text-right">{{$money(invoice.TaxVat)}}</th>
                                        </tr>
                                        <tr>
                                            <th colspan="6" class="none-ltb text-right">{{$t('grand_total')}}:</th>
                                            <th class="text-right">{{$money(invoice.PaidAmount)}}</th>
                                        </tr>
                                    </tbody>
                            </table>
                        </div>
                    </div>            
                </div>
            </div>
        </div>
    </div>
    <VendorFormModal ref="mVendor" @done="done" :name="vendorName"></VendorFormModal>
    <ItemFormModal ref="mItem" @done="doneItem" :name="itemName" />
</div>
</template>
<script>
    import DatePicker from '../Components/DatePicker.vue'
    import { AuthCompleted } from '../Item';
    import { VendorSelector, VendorFormModal } from '../Vendors';
    import {required} from 'vuelidate/lib/validators';
    import Purchase from '../../shared/models/Purchase';
    import AccountAutoComplete from '../Accountings/Components/AutoComplete.vue'
    import { ItemFormModal } from "../Item";
    export default {
        components: {
            AuthCompleted,
            VendorSelector,
            VendorFormModal,
            DatePicker,
            AccountAutoComplete,
            ItemFormModal
        },
        data: function(){
            return {
                invoice: JSON.parse(JSON.stringify(Purchase.orderHeader)),
                lines: [
                    JSON.parse(JSON.stringify(Purchase.orderLine)),
                    JSON.parse(JSON.stringify(Purchase.orderLine)),
                    JSON.parse(JSON.stringify(Purchase.orderLine)),
                    JSON.parse(JSON.stringify(Purchase.orderLine)),
                    JSON.parse(JSON.stringify(Purchase.orderLine))
                ],
                expense_lines: [
                    JSON.parse(JSON.stringify(Purchase.orderLine)),
                    JSON.parse(JSON.stringify(Purchase.orderLine)),
                    JSON.parse(JSON.stringify(Purchase.orderLine)),
                    JSON.parse(JSON.stringify(Purchase.orderLine)),
                    JSON.parse(JSON.stringify(Purchase.orderLine))
                ],
                account_payables: [],
                accounts: [],
                date: this.$now().format('YYYY-MM-DD'),
                due_date: this.$now().format('YYYY-MM-DD'),
                actionLink: 'po/invoice/save',
                branches: [],
                vendorName: '',
                activeTab: 1,
                itemName: "",
            }
        },
        validations:{
            invoice: {
                VendorId: { required },
                AccountId: { required },
                Date: { required }
            },
        },
        async created() {
            this.invoice.Date = this.date;            
            this.invoice.DueDate = this.due_date;            
            this.branchList();
            this.fetchAccount();
            let id = this.$route.params.id;            
            this.invoice.CompanyId = this.$store.state.company.Id;
            if(id !== undefined && id != null && id !== ''){
                let loading = this.$loading.show();
                this.actionLink = 'po/invoice/update';
                await this.$api().post('po/invoice/find', { Id: id }).then(res => {                                        
                    var data = res.data.Data;                    
                    this.invoice = data.POInvoice;
                    this.date = data.POInvoice.Date; 
                    this.due_date = data.POInvoice.DueDate; 
                    this.lines = data.POInvoiceLines.filter((e) => e.ItemId != null);
                    this.expense_lines = data.POInvoiceLines.filter((e) => e.AccountId != null);                    
                    this.reCalculate();
                    this.activeTab = 1;                    
                }).finally(function() { loading.hide(); });
            }            
            this.fetchExchangeRate(this.invoice);            
        },
        watch: {
            "date"() {
                this.fetchExchangeRate(this.invoice);
            },            
        },
        computed: {
            "AmountKHR"() {
                return this.invoice.PaidAmount * this.invoice.ExchangeRate || 0;
            }
        },
        methods: {
            branchList(){
                this.$api().post('branch/list', { CompanyId: this.$store.state.company.Id }).then(res => {
                    if(this.$isValid(res)){
                        this.branches = res.data.Json.Branches;
                    }
                });
            },
            fetchAccount() {                
                this.$api().post('accounting/accounting-init-invoice', { CompanyId: this.$store.state.company.Id }).then(res => {
                    if(this.$isValid(res)){     
                        if(res.data.Json.AccountPayables.length > 0) this.invoice.AccountId = res.data.Json.AccountPayables[0].Id;                   
                        this.account_payables = res.data.Json.AccountPayables;
                        this.accounts = res.data.Json.Accounts;
                    }
                });
            },
            done(e){
                this.invoice.VendorId= e.Id,
                this.invoice.VendorName = e.Name;
            },
            vendorSelected(evt){
                if(evt.type == 1){
                    this.vendorName = evt.data.Text
                    this.$refs.mVendor.$refs.innermodal.show();
                }else{
                    this.invoice.VendorId = evt.data.Id;
                    this.invoice.VendorName = evt.data.Name;
                    this.invoice.Phone = evt.data.Phone;
                }
            },
            async onSave(type){                            
                this.$v.$touch();
                if(!this.$v.$invalid) {
                    this.invoice.Date = this.date;
                    this.invoice.DueDate = this.due_date;
                    this.invoice.CompanyId = this.$store.state.company.Id;
                    this.invoice.ClientId = this.$store.state.company.ClientId;
                    let req_lines= [];
                    let req_expense_lines= [];
                    this.lines.filter((el) => {
                        if(el.ItemId != "") req_lines.push(el);
                    });
                    this.expense_lines.filter((el) => {
                        if(el.AccountId != "") req_expense_lines.push(el);
                    });
                    if (req_lines.length == 0 && req_expense_lines.length == 0) {
                        this.$swal.fire("សារបញ្ជាក់", "សូមធ្វើការជ្រើសរើសទំនិញយ៉ាងតិច១។", "warning");
                    } else {          
                        const loading = this.$loading.show();
                        const req = {
                            Header: this.invoice,
                            Lines: req_lines,
                            ExpenseLines: req_expense_lines
                        };
                        await this.$api().post(this.actionLink, req).then(res => {
                            if (this.$isValid(res)) {                                
                                if(type == 'new') {
                                    this.$v.$reset();
                                    this.invoice = JSON.parse(JSON.stringify(Purchase.orderHeader));
                                    this.lines = [
                                        JSON.parse(JSON.stringify(Purchase.orderLine)),
                                        JSON.parse(JSON.stringify(Purchase.orderLine)),
                                        JSON.parse(JSON.stringify(Purchase.orderLine)),
                                        JSON.parse(JSON.stringify(Purchase.orderLine)),
                                        JSON.parse(JSON.stringify(Purchase.orderLine))
                                    ];
                                    this.expense_lines = [
                                        JSON.parse(JSON.stringify(Purchase.orderLine)),
                                        JSON.parse(JSON.stringify(Purchase.orderLine)),
                                        JSON.parse(JSON.stringify(Purchase.orderLine)),
                                        JSON.parse(JSON.stringify(Purchase.orderLine)),
                                        JSON.parse(JSON.stringify(Purchase.orderLine))
                                    ];                                    
                                    this.vendorName = '';
                                    this.activeTab = 1;
                                    this.itemName = "";
                                    this.due_date = this.$now().format('YYYY-MM-DD');
                                    if(this.$route.params.id) this.$router.push('/purchase/invoice');
                                    if(this.account_payables.length > 0) this.invoice.AccountId = this.account_payables[0].Id;                   
                                } else if(type == 'print') {
                                    let link = '/print/purchase/' + res.data.Json.header.Id;
                                    window.open(link, '_blank');
                                    this.$router.go(-1);
                                } else {
                                    this.$router.go(-1);
                                }
                            }
                        }).finally(function () {
                            loading.hide();
                        });
                    }                       
                }
            },
            select(item, line) {
                if (item.type == 3) {
                    line.ItemId = item.data.Id;
                    line.ItemName = item.data.Name;
                    line.Description = item.data.Name;                
                    line.Price = item.data.Cost;
                    this.reCalculate();
                } else if (item.type == 1) {
                    this.add_item_line_no = item.data.line_no;
                    this.$refs.mItem.$refs.innermodal.show();
                } else if (item.type == 4) {
                    this.lines[item.line_no].ItemId = item.Id;
                    this.lines[item.line_no].ItemName = item.Name;
                    this.lines[item.line_no].Description = item.Name;
                    this.lines[item.line_no].Price = item.Cost;
                }
            },
            selectAccount(item, line) {
                line.AccountId = item.data.Id;                
            },
            reCalculate(){
                let grand = 0;
                let totalTax = 0;
                this.lines.map(item => {
                    let subTotal = (item.Quantity * item.Price) - (item.Quantity * item.Price * item.Discount / 100);
                    item.SubTotal = subTotal;
                    grand += subTotal;
                    let tax = subTotal * (item.TaxLine / 100);
                    totalTax += tax;
                });
                this.expense_lines.map(item => {
                    let subTotal = (item.Quantity * item.Price) - (item.Quantity * item.Price * item.Discount / 100);
                    item.SubTotal = subTotal;
                    grand += subTotal;
                    let tax = subTotal * (item.TaxLine / 100);
                    totalTax += tax;
                });
                this.invoice.GrandTotal = grand;
                let amount = grand - (Number(this.invoice.Discount) + Number(this.invoice.Deposit));
                this.invoice.TaxVat = totalTax;
                this.invoice.PaidAmount = amount + totalTax;
                this.invoice.Balance = amount + totalTax;
            },
            addLine(type){
                if(type == "expense") this.expense_lines.push(JSON.parse(JSON.stringify(Purchase.orderLine)));
                this.lines.push(JSON.parse(JSON.stringify(Purchase.orderLine)));
            },
            removeLine(index){
                if(this.lines.length > 1){
                    this.lines.splice(index, 1);
                }
            },            
            poChange(e){
                if(e.type == 1)
                {
                    let loading = this.$loading.show();
                    this.invoice.DocSource = 'Order';
                    Purchase.findOrderById({ Id: e.data.Id }).then(data => {
                        this.lines = [];
                        this.invoice.VendorId = data.Header.VendorId;
                        this.invoice.PartnerName = data.Header.PartnerName;
                        this.invoice.GrandTotal = data.Header.GrandTotal;
                        this.invoice.UntaxAmount = data.Header.GrandTotal;
                        this.invoice.TaxVat = data.Header.TaxVat;
                        this.invoice.PaidAmount = data.Header.PaidAmount;
                        this.invoice.Balance = data.Header.PaidAmount;
                        this.invoice.DocSourceNo = data.Header.Num;
                        this.invoice.BranchId = data.Header.BranchId;
                        data.Lines.forEach(element => {
                            this.lines.push({
                                ItemId: element.ItemId,
                                ItemName: element.ItemName,
                                Description: element.Description,
                                Quantity: element.Quantity,
                                Price: element.Price,
                                TaxLine: element.TaxLine,
                                SubTotal: element.SubTotal
                            });
                        });
                    }).finally(() => { loading.hide(); });
                }
                else{
                    this.invoice.DocSource = '';
                    this.invoice.DocSourceNo = '';
                }
            },
            async fetchExchangeRate() {                                        
                await this.$api()
                    .post("invoice/exchangerate-by-date", {
                        Date: this.$formatFromTo(this.invoice.Date, 'DD-MM-YYYY', 'YYYY-MM-DD'),
                        CompanyId: this.invoice.CompanyId
                    })
                    .then((res) => {
                    if (this.$isValid(res)) {
                        if (res.data.Json.Rate) {
                            this.invoice.ExchangeRate = res.data.Json.Rate.Value;                               
                        }
                        else this.invoice.ExchangeRate = 0;
                    }
                });
            },
            Tabs(index){
                return this.activeTab === index
            },
            OnTabs(index){
                this.activeTab = index
            },
            doneItem(e) {
                if (this.add_item_line_no != null || this.add_item_line_no != undefined) {
                    e.line_no = this.add_item_line_no;
                    e.type = 4;
                    this.select(e, "");
                    this.add_item_line_no = null;
                }
            },
        }
    }
</script>

<style scoped lang="scss">

    label{
        margin-bottom: 0;
    }
    .none-ltb{
        border-left: none;
        border-top: none;
        border-bottom: none;
    }
    .none-right {
        border-right: none;
    }    
    .none-border{
        border-top: 0;
        border-left: 0;
        border-width: 2px;
        border-right: 0;
    }
</style>
